import { Injectable } from '@angular/core';
import {Offer} from '../../../../models/offer/offer.model';
import {SelectedOfferService} from '../selected-offer/selected-offer.service';
import {RegistrationService} from '../../registration.service';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {OfferPremium} from '../../../../models/offer/offer-premium.model';
import {OfferPremiumInstallmentCode} from '../../../../consts/offer-premium-installment-code.enum';

@Injectable({
  providedIn: 'root'
})
export class InstallmentStateService {

  get selectedOffer(): Offer {
    return this.selectedOfferService.selectedOffer;
  }

  get premiumId(): string {
    return this.registrationService.premiumId;
  }

  get firstInstallmentValue(): number | null {
    if (isNotNullOrUndefined(this.premiumId) && isNotNullOrUndefined(this.selectedOffer)) {
      const selectedPremium = this.selectedOffer.premiums.find(premium => premium.id === this.premiumId);
      if (isNotNullOrUndefined(selectedPremium)) {
        if (selectedPremium.instalments.length > 1) {
          return selectedPremium.instalments[0].value;
        }
      }
    }
    return null;
  }

  constructor(private selectedOfferService: SelectedOfferService,
              private registrationService: RegistrationService) { }

  getPremiumsSortedByAmount(offer: Offer = this.selectedOffer): OfferPremium[] {
    return offer.premiums.sort((a, b) => a.instalments.length - b.instalments.length);
  }

  getLowestFirstInstallmentValue(offer: Offer): number {
    if (isNotNullOrUndefined(offer)) {
      const installmentsValues = offer.premiums
          .map(premium => premium.instalments[0])
          .map(installment => installment.value);
      return Math.min(...installmentsValues);
    }
    return null;
  }

  createTilesData(offer: Offer = this.selectedOffer): InstallmentTileData[] {
    return this.getPremiumsSortedByAmount(offer).map(premium => ({
      premiumId: premium.id,
      label: `INSTALLMENT_SECTION.INSTALLMENTS.${premium.instalments.length}`,
      premiumAmount: premium.amount.amount,
      firstInstallmentAmount: this.isPremiumMultiInstallment(premium) ? this.getPremiumFirstInstallmentValue(premium) : undefined
    }));
  }

  private isPremiumMultiInstallment(premium: OfferPremium): boolean {
    return premium.instalments.length > 1;
  }

  private getPremiumFirstInstallmentValue(premium: OfferPremium): number {
    const firstInstallment = premium.instalments.find(installment => installment.code === OfferPremiumInstallmentCode.ONE_INSTALMENT);
    return firstInstallment ? firstInstallment.value : null;
  }
}

export interface InstallmentTileData {
  premiumId: string;
  label: string;
  premiumAmount: number;
  firstInstallmentAmount?: number;
}
